import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import Button from 'components/Button/index'
import { Input ,Col} from 'antd';


export const SectionWrapper = styled(Flex)`
  width: 100%;
  border: 1px solid ${COLORS.PAGE_BORDER};
  box-shadow: 0px 2px 6px rgba(123, 97, 255, 0.15);
  margin: 30px 100px 20px 100px;
  border-radius: 10px;
  overflow: scroll;
  background: ${COLORS.WHITE};
  &::-webkit-scrollbar {
    display: none;
  }
  @media only screen and (max-device-width: 767px) {
    margin: 10px;
  }
  @media only screen and (min-width: 1200px) and (max-width: 1300px) {
    margin: 30px 20px 20px 20px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    margin: 10px;
  }
`

export const TopHeader = styled(Flex)`
  padding: 20px 25px;
  position: relative;
  width: 100%;
  font-size: 2em;
`
export const TopHeading = styled(Flex)`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`

export const TopRightFlex = styled(Flex)`
  gap: 15px;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  > div {
    margin-left: 0;
  }
`
export const CardRow = styled(Flex)`
  padding: 0 25px 25px 25px;
  gap: 20px;
`
export const SearchDiv = styled.div`
  padding: 10px 20px;
`
export const TabDiv = styled.div`
  padding: 0px 20px 20px 20px;
`


export const Name1 = styled.div`
  font-weight: 600;
  font-size: 16px;
  height: 21px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  text-transform: capitalize;
  @media only screen and (max-device-width: 767px) {
    font-size: 12px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 12px;
    line-height: 18px;
  }
`

export const Name = styled.div`
font-style: normal;
font-weight: 500;
font-size: 14px;
line-height: 18px;
color: #343E59;

  text-transform: capitalize;
  @media only screen and (max-device-width: 767px) {
    font-size: 12px;
    line-height: 18px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 12px;
    line-height: 18px;
  }
`

export const Address = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #1b1f22;
  opacity: 0.48;
  @media only screen and (max-device-width: 767px) {
    font-size: 10px;
    line-height: 16px;
  }
  @media only screen and (min-width: 768px )  and  (max-width : 1200px){
    font-size: 10px;
    line-height: 16px;
  }
`

export const NameAdd = styled(Flex)`
  gap: 3px;
`
export const FullTable = styled.table`
  margin: 0;
  padding: 0;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 10px;
`
export const SlRow = styled.tr`
  padding: 10px;
  height: 103px;
  border-radius: 10px !important;
  border: 1px solid #e6e7ea !important;
  box-shadow: 0px 2px 8px 8px rgba(201, 201, 201, 0.1),
    inset 0px -1px 0px rgba(0, 0, 0, 0.05);
`

export const SlCol = styled.td`
  td {
    border: 1px solid #e6e7ea;
    border-style: solid none;
    padding: 10px;
  }
`
export const SlCol1 = styled.td`
  padding-left: 15px;
`
export const ContentCenterDiv = styled.div`
  text-align: center;
`
export const LeftAlignCol = styled(Col)`
padding-left: 10px;
`
export const SearchInput = styled(Input)`
::placeholder {
  font-size: 16px;
}
width: ${props => (props.width ? props.width : '250px')} !important;
height: ${props => (props.height ? props.height : '40px')};
border-radius: 8px;
box-shadow: none;
border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
:focus {
  border-color: #e9e9e9;
  box-shadow: none;
}
:hover {
  border-color: #e9e9e9;
}
:not(.ant-input-affix-wrapper-disabled):hover {
  border-color: #e9e9e9 !important;
}
.ant-input-affix-wrapper-focused {
  box-shadow: none;
  border-right-width: 0px !important;
}
`

export const SpinWrapper = styled(Flex)`
  padding-top: 25px;
`